(function () {
  class GrDoubleSlider {
    
    constructor(root) {
      this.root = root;
      this.panels = root.querySelector('[data-panels]');
      this.productTrack = root.querySelector('[data-track="product"]');
      this.productSlides = Array.from(
        root.querySelectorAll('[data-track="product"] [data-slide]')
      );
      this.ticks = Array.from(root.querySelectorAll('[data-goto]'));
      this.titleEl = root.querySelector('[data-title-display]');
      this.index = 0;
      this.total = this.productSlides.length;
      this.pointerActive = false;
      this.dragging = false;
      this.moved = false;
      this.lockAxis =  (null);
      this.startX = 0;
      this.startY = 0;
      this.deltaX = 0;
      this.pointerId = null;

      if (!this.panels || this.total === 0 || !this.productTrack) return;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);

      root.querySelector('[data-prev]')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.goTo(this.index - 1);
      });
      root.querySelector('[data-next]')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.goTo(this.index + 1);
      });

      this.ticks.forEach((tick) => {
        tick.addEventListener('click', (e) => {
          e.preventDefault();
          const next = Number(tick.getAttribute('data-goto'));
          if (!Number.isNaN(next)) this.goTo(next);
        });
      });

      this.productSlides.forEach((slide) => {
        slide.addEventListener('click', (e) => this.onSlideClick(e, slide));
      });

      const productPanel = root.querySelector('.gr-double-slider__panel--product');
      const dragTarget = productPanel instanceof HTMLElement ? productPanel : this.panels;
      this.dragTarget = dragTarget;
      dragTarget.addEventListener('pointerdown', this.onPointerDown);

      this.goTo(0, false);

      window.addEventListener('resize', () => {
        if (!this.dragging) this.setTrack(this.index, false, 0);
      });
    }

    
    onSlideClick(e, slide) {
      e.preventDefault();
      e.stopPropagation();
      if (this.moved) return;

      const next = Number(slide.dataset.index);
      if (Number.isNaN(next)) return;

      if (next !== this.index) {
        this.goTo(next);
        return;
      }

      const url = slide.dataset.url;
      if (url) window.location.href = url;
    }

    
    setTrack(index, animate, dragOffset = 0) {
      if (!this.productTrack) return;

      this.root.classList.toggle('is-instant', !animate);

      const stack = this.productTrack.closest('.gr-double-slider__stack');
      const slideW =
        stack instanceof HTMLElement && stack.clientWidth > 0
          ? stack.clientWidth
          : 259;
      const x = -index * slideW + dragOffset;
      this.productTrack.style.transform = `translate3d(${x}px, 0, 0)`;

      if (!animate) {
        requestAnimationFrame(() => this.root.classList.remove('is-instant'));
      }
    }

    
    goTo(index, animate = true) {
      if (this.total === 0) return;
      this.index = ((index % this.total) + this.total) % this.total;

      this.productSlides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
      });

      this.ticks.forEach((tick, i) => {
        const on = i === this.index;
        tick.classList.toggle('is-active', on);
        tick.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      const active = this.productSlides[this.index];
      if (this.titleEl && active) {
        this.titleEl.textContent = active.dataset.title || '';
      }

      this.setTrack(this.index, animate, 0);
    }

    
    onPointerDown(e) {
      if (e.button !== 0) return;
      if (e.target instanceof Element && e.target.closest('.gr-double-slider__nav, .gr-double-slider__tick')) {
        return;
      }

      this.pointerActive = true;
      this.dragging = false;
      this.moved = false;
      this.lockAxis = null;
      this.pointerId = e.pointerId;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.deltaX = 0;

      this.dragTarget.addEventListener('pointermove', this.onPointerMove, { passive: false });
      this.dragTarget.addEventListener('pointerup', this.onPointerUp);
      this.dragTarget.addEventListener('pointercancel', this.onPointerUp);
    }

    
    onPointerMove(e) {
      if (!this.pointerActive) return;
      if (this.pointerId !== null && e.pointerId !== this.pointerId) return;

      const dx = e.clientX - this.startX;
      const dy = e.clientY - this.startY;

      if (!this.lockAxis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        this.lockAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';

        if (this.lockAxis === 'y') {
          this.teardownPointer();
          return;
        }

        this.dragging = true;
        this.moved = true;
        this.root.classList.add('is-dragging');
        try {
          this.dragTarget.setPointerCapture(e.pointerId);
        } catch (_) {
          
        }
      }

      if (this.lockAxis !== 'x') return;
      e.preventDefault();
      this.deltaX = dx;
      this.setTrack(this.index, false, dx);
    }

    onPointerUp() {
      if (!this.pointerActive && !this.dragging) return;
      const wasDragging = this.dragging;
      const deltaX = this.deltaX;
      this.teardownPointer();

      if (!wasDragging) {
        this.setTrack(this.index, true, 0);
        return;
      }

      const threshold = Math.min(56, Math.max(36, (this.dragTarget?.clientWidth || 300) * 0.08));
      if (deltaX > threshold) this.goTo(this.index - 1);
      else if (deltaX < -threshold) this.goTo(this.index + 1);
      else this.goTo(this.index);

      window.setTimeout(() => {
        this.moved = false;
      }, 80);
    }

    teardownPointer() {
      this.pointerActive = false;
      this.dragging = false;
      this.lockAxis = null;
      this.root.classList.remove('is-dragging');

      this.dragTarget.removeEventListener('pointermove', this.onPointerMove);
      this.dragTarget.removeEventListener('pointerup', this.onPointerUp);
      this.dragTarget.removeEventListener('pointercancel', this.onPointerUp);

      if (this.pointerId !== null) {
        try {
          this.dragTarget.releasePointerCapture(this.pointerId);
        } catch (_) {
          
        }
        this.pointerId = null;
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-gr-double-slider]').forEach((root) => {
      if (!(root instanceof HTMLElement) || root.dataset.grDsReady === 'true') return;
      root.dataset.grDsReady = 'true';
      new GrDoubleSlider(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-gr-double-slider]').forEach((root) => {
      if (root instanceof HTMLElement) delete root.dataset.grDsReady;
    });
    init();
  });
})();
